import React from "react"
import PropTypes from "prop-types"
import ErrorText from "@irati/ui/src/ErrorText"
import getErrorValues from "../helpers/getErrorValues"

const LoadingError = (props) => {
  const {networkError} = props.apollo.error
  const values = getErrorValues(networkError)

  return (
    <ErrorText {...props} values={values}>
      {props.errorMsg}
    </ErrorText>
  )
}

LoadingError.propTypes = {
  errorMsg: PropTypes.string.isRequired,
  apollo: PropTypes.object.isRequired
}

export default LoadingError
